/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ pct: NonNullable<unknown> }} Wrapped_Volume_BestInputs */

const en_us2_wrapped_volume_best = /** @type {(inputs: Wrapped_Volume_BestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Your strongest week yet, ${i?.pct}% above the one before.`)
};

const pt_br2_wrapped_volume_best = /** @type {(inputs: Wrapped_Volume_BestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sua semana mais forte até agora, ${i?.pct}% acima da anterior.`)
};

const es_419_wrapped_volume_best = /** @type {(inputs: Wrapped_Volume_BestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tu semana más fuerte hasta ahora, ${i?.pct}% más que la anterior.`)
};

const pt_pt2_wrapped_volume_best = /** @type {(inputs: Wrapped_Volume_BestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A tua semana mais forte até agora, ${i?.pct}% acima da anterior.`)
};

const fr_fr2_wrapped_volume_best = /** @type {(inputs: Wrapped_Volume_BestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ta semaine la plus forte à ce jour, ${i?.pct} % au-dessus de la précédente.`)
};

const de_de2_wrapped_volume_best = /** @type {(inputs: Wrapped_Volume_BestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Deine bisher stärkste Woche, ${i?.pct} % mehr als die davor.`)
};

const it_it2_wrapped_volume_best = /** @type {(inputs: Wrapped_Volume_BestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`La tua settimana più forte finora, ${i?.pct}% in più della precedente.`)
};

/**
* | output |
* | --- |
* | "Your strongest week yet, {pct}% above the one before." |
*
* @param {Wrapped_Volume_BestInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_volume_best = /** @type {((inputs: Wrapped_Volume_BestInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Volume_BestInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_volume_best(inputs)
	if (locale === "es-419") return es_419_wrapped_volume_best(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_volume_best(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_volume_best(inputs)
	if (locale === "de-DE") return de_de2_wrapped_volume_best(inputs)
	if (locale === "it-IT") return it_it2_wrapped_volume_best(inputs)
	return en_us2_wrapped_volume_best(inputs)
});
export { wrapped_volume_best as "wrapped.volume_best" }